import dynamic from "next/dynamic";
import qs from "qs";
import { GetServerSideProps } from "next";

const ServicesPage = dynamic(() => import("@/Components/pages/Services"));

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59",
    );
  }

  //   const slug = ctx.params?.slug as string;

  const query = qs.stringify(
    {
      filters: {
        slug: {
          $eq: "services",
        },
      },
      populate: "deep, 8",
    },
    {
      encodeValuesOnly: false,
    },
  );

  const apiRes = await fetch(
    `${baseUrl}services-page-v2s/?${decodeURIComponent(query)}`,
  );
  const apiResData = await apiRes.json();

  const userAgent = ctx.req.headers["user-agent"] || "";

  const isMobile =
    /iphone|ipod|android.*mobile|blackberry|iemobile|opera mini/i.test(
      userAgent,
    );

  const isProbablyTarget = isMobile;

  const listData = apiResData?.data[0].attributes;

  if (!listData) {
    return { notFound: true };
  }
  // if (!listData.length) {
  //   return { notFound: true };
  // }

  const blocksData = listData.blocks ?? null;
  const seoData = listData.seo ?? null;

  return {
    props: {
      blocksData,
      seoData,
      isMobile: isProbablyTarget,
    },
  };
};

interface ServiceProps {
  blocksData: any;
  seoData: any;
  isMobile: boolean;
}

const Service: React.FC<ServiceProps> = ({ blocksData, seoData, isMobile }) => {
  return (
    <>
      <ServicesPage data={blocksData} isMobile={isMobile} seo={seoData} />
    </>
  );
};

export default Service;
